import { BarceloComponent } from "components-utils";

const IAComponents = {
  IAList: BarceloComponent({
    selector: ".ia-list-dl-id, .ia-list__content",
    path: "barcelo/ia/ia-list/js/ia-list",
  }),
};

export default IAComponents;
